// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"0e33869d81cb4d36","473":"70deb59cbee34b13","888":"2027486e0468a046","899":"ed551f017059aa7d"}[chunkId] + ".css";
};